var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{ref:"dataviz",staticClass:"customAnalyticPlaceholder ma-0",style:(_vm.currentStyleRules)},[_c('tableau-viz',{ref:"tableau",attrs:{"id":"tableauViz","src":_vm.currentSrc,"token":_vm.jwt,"device":_vm.device,"height":`${_vm.currentHeight}px`,"hide-tabs":_vm.hideTabs,"width":`${_vm.currentWidth}px`,"toolbar":_vm.toolbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }